/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTaskAttachment200Response
 */
export interface CreateTaskAttachment200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateTaskAttachment200Response
     */
    taskAttachmentId?: string;
}

/**
 * Check if a given object implements the CreateTaskAttachment200Response interface.
 */
export function instanceOfCreateTaskAttachment200Response(value: object): value is CreateTaskAttachment200Response {
    return true;
}

export function CreateTaskAttachment200ResponseFromJSON(json: any): CreateTaskAttachment200Response {
    return CreateTaskAttachment200ResponseFromJSONTyped(json, false);
}

export function CreateTaskAttachment200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTaskAttachment200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'taskAttachmentId': json['taskAttachmentId'] == null ? undefined : json['taskAttachmentId'],
    };
}

export function CreateTaskAttachment200ResponseToJSON(json: any): CreateTaskAttachment200Response {
    return CreateTaskAttachment200ResponseToJSONTyped(json, false);
}

export function CreateTaskAttachment200ResponseToJSONTyped(value?: CreateTaskAttachment200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskAttachmentId': value['taskAttachmentId'],
    };
}

